module.exports = __webpack_public_path__ + "img/smartphoenix-logo.3fb05f83.png";